import React, {useContext, useEffect} from "react";
// @ts-ignore
import LoginBtn from '../components/login/LoginBtn';
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../components/helper/AuthContext";

const Login = () => {
  const { currentUser, triggerLogin } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate('/booking');
    }
  }, [currentUser]);

  return <LoginBtn login={triggerLogin}/>
};

export default Login;
